<div class="sx-snackbar-container">
    <div class="sx-snackbar__body">
        <h4 *ngIf="data.title && data.title !==''">{{data.title}}</h4>
        <span class="sx-snackbar__message" data-cy="snackbar-message" *ngIf="data.message && data.message !=='' && data.validationErrors?.length !== 1">{{data.message}}</span>
        
        <span class="sx-snackbar__message" data-cy="snackbar-message" *ngIf="data.validationErrors?.length === 1">{{data.validationErrors[0].message}}</span>
        
        <ul *ngIf="data.validationErrors && data.validationErrors.length > 1">
            <li *ngFor="let item of data.validationErrors">{{item.field}} - {{item.message}}</li>
        </ul>
    </div>
    <div *ngIf="hasAction">
        <span (click)="action()">
            <svg class="sx-snackbar__action">
                <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
            </svg>
        </span>
    </div>
    <div class="sx-snackbar__buttons" *ngIf="data.snackbarType === 'error' && !data.showReAuth" >
        <button mat-button class="sx-button sx-button--red" (click)="action()">
            <svg class="sx-snackbar__action">
                <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
            </svg>
        </button>
    </div>
</div>